const MutationObserver = window.MutationObserver || (window as any).WebKitMutationObserver;

const setupBodyMutationObserver = (callback: () => void) => {
    const elements: HTMLImageElement[] = [];

    function addImageLoadListener(element: HTMLImageElement) {
        if (!element.complete) {
            element.addEventListener('load', imageEventTriggered, false);
            element.addEventListener('error', imageEventTriggered, false);
            elements.push(element);
        }
    }

    function removeImageLoadListener(element: HTMLImageElement) {
        element.removeEventListener('load', imageEventTriggered, false);
        element.removeEventListener('error', imageEventTriggered, false);
        elements.splice(elements.indexOf(element), 1);
    }

    function imageEventTriggered(event: Event) {
        const target = event.target as HTMLImageElement;
        removeImageLoadListener(target);
        callback();
    }

    function addImageLoadListeners(mutation: MutationRecord) {
        if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'src' &&
            mutation.target instanceof HTMLImageElement
        ) {
            addImageLoadListener(mutation.target);
            return;
        }

        if (mutation.type === 'childList' && mutation.target instanceof HTMLElement) {
            mutation.target.querySelectorAll('img').forEach(addImageLoadListener);
        }
    }

    function mutationObserved(mutations: MutationRecord[]) {
        callback();

        // Deal with WebKit / Blink asyncing image loading when tags are injected into the page
        mutations.forEach(addImageLoadListeners);
    }

    const createMutationObserver = () => {
        const target: HTMLBodyElement = document.querySelector('body')!;
        const config = {
            attributes: true,
            attributeOldValue: false,
            characterData: true,
            characterDataOldValue: false,
            childList: true,
            subtree: true,
        };

        const observer = new MutationObserver(mutationObserved);
        observer.observe(target, config);
        return observer;
    };

    const observer = createMutationObserver();

    return () => {
        if ('disconnect' in observer) {
            observer.disconnect();
        }
        elements.forEach(removeImageLoadListener);
    };
};

export const setupMutationObserver = (callback: () => void) => {
    if (!!MutationObserver) {
        return setupBodyMutationObserver(callback);
    }

    // Interval fallback
    const intervalTimer = setInterval(callback, 100);
    return () => clearInterval(intervalTimer);
};
